



































































































































































































import Vue from './mixin'

import { Upload, Button, Dialog } from 'element-ui'

import { Stack, FindStacks } from '@/api/cems'
import { baseUrl, GetSVGFile, UploadFile } from '@/api/svg'
import { SVGToImage, SVGToBase64, StringToSVGElement } from '@/utils/svg'
import { DownloadBase64File } from '@/utils/download'

interface ElUpladConfig {
  action: string
  data?: any
  file: File
  filename: string
  onError: (err: any) => void
  onProgress: (args: any) => void
  onSuccess: (args: any) => void
}

interface ElFile {
  name: string
  percentage?: 0
  raw?: File
  size: number
  status?: string
  uid?: number
  url: string
}

export default Vue.extend({
  name: 'EditView',
  components: {
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      roles: [] as string[],
      chimneys: [] as string[],

      stacks: [] as Stack[],

      newStack: '',

      dialogImageVisible: false,
      dialogImageUrl: '',
      fileChanged: false,
      svgFileString: '',
      fileList: [] as ElFile[],
    }
  },

  methods: {
    onPreviewClick(file: any) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },

    async onDownloadFileClick(file: ElFile) {
      const el = StringToSVGElement(this.svgFileString)
      const b64 = SVGToBase64(el)
      DownloadBase64File(file.name + '.svg', b64)
    },

    onRemoveFileClick(file: ElFile) {
      console.log(file)
      this.fileList = []
    },

    onUploadFileChange(file: ElFile, fileList: ElFile[]) {
      this.fileList = fileList.slice(-1)
      this.fileChanged = true
    },

    onUploadError(response: any, file: any, fileList: any) {
      console.log(response)
    },

    async httpRequest(arg: ElUpladConfig) {
      await UploadFile(this.viewProperties.uid, arg.file)
      await this.loadSvgProperties()
      await this.loadSvgFile()
    },

    onNewStackSelected() {
      this.chimneys.push(this.newStack)
      this.newStack = ''
    },

    onChimneyRemoved(index: number) {
      this.chimneys.splice(index, 1)
    },

    updateProperties() {
      this.viewProperties.roles = this.roles.join(',')
      this.viewProperties.defaultStacks = this.chimneys.join(',')
      this.patchSVGProperties()
    },
    submitUpload() {
      // eslint-disable-next-line
      ;(this as any).$refs.upload.submit()
    },

    async loadSvgProperties() {
      await this.getProperties()
      this.roles = this.viewProperties.roles.split(',')
      if (this.viewProperties.defaultStacks) {
        this.chimneys = this.viewProperties.defaultStacks.split(',')
      }
    },

    async loadSvgFile() {
      if (this.fileList.length > 0 && !this.fileChanged) {
        return
      }
      this.svgFileString = await GetSVGFile(
        this.viewProperties.uid,
        this.viewProperties.slug
      )

      const url = await SVGToImage(this.svgFileString, 'base64')
      if (typeof url == 'string') {
        this.fileList = [
          {
            name: this.viewProperties.name,
            url,
            size: this.viewProperties.fileZise,
          },
        ]

        this.fileChanged = false
      }
    },
  },

  computed: {
    url(): string {
      return `/api/v1${baseUrl}/upload/${this.viewProperties.uid}`
    },
  },

  async created() {
    this.stacks = await FindStacks()
    await this.loadSvgProperties()
  },
})
